export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-accent-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
            联系我们
          </h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10 ml-11">
          欢迎影迷朋友与我们交流互动
        </p>

        <div className="rounded-lg bg-background-100 border border-background-200/60 p-6 md:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-500/10 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-lg text-accent-400"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-200 mb-1">投稿与合作</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  如果您有优质影片资源或合作意向，欢迎通过邮件与我们联系。
                </p>
                <span className="inline-block mt-2 text-xs text-primary-400">contact@wukongmovie.com</span>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-primary-500/10 flex items-center justify-center flex-shrink-0">
                <i className="ri-question-answer-line text-lg text-primary-400"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-200 mb-1">影迷反馈</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  对悟空影视有任何建议或意见？我们珍视每一位影迷的声音，期待您的反馈。
                </p>
                <span className="inline-block mt-2 text-xs text-primary-400">feedback@wukongmovie.com</span>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-secondary-500/10 flex items-center justify-center flex-shrink-0">
                <i className="ri-share-line text-lg text-secondary-400"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-200 mb-1">社交媒体</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  关注悟空影视的社交媒体账号，获取最新电影推荐和平台动态。
                </p>
                <div className="flex items-center gap-3 mt-2">
                  <span className="text-xs text-foreground-500">@wukongmovie</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}